

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UsersFakeData } from '@fake-db/users.data';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class UserListService {

  private currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null;
  private companyId = this.currentUser?.assignedCompany.id || null;

  public rows: any;
  public onUserListChanged: BehaviorSubject<any>;
  constructor(private _httpClient: HttpClient) {
    this.onUserListChanged = new BehaviorSubject({});
    this.getDataTableRows();
  }

  private apiUrl = environment.apiUrl + '/users';




  // User List
  getUsers(): Observable<any> {
    return this._httpClient.get<any>(this.apiUrl);
  }

  getRoles(): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/roles?status=true`;
    return this._httpClient.get<any>(url);
  }

  // Add User
  addUser(data: any): Observable<any> {
    return this._httpClient.post<any>(this.apiUrl, data);
  }

  // Update User
  updateUser(_id: string, data: any): Observable<any> {
    return this._httpClient.patch<any>(`${this.apiUrl}/${_id}`, data);
  }





  private apiUrlCall = environment.apiUrl + '/calls';

  // Calls List
  getCalls(): Observable<any> {
    if (!this.companyId) return new Observable<any>();
    if (this.currentUser.role == 'admin') {
      return this._httpClient.get<any>(this.apiUrlCall + '?companyId=' + this.companyId + '&limit=1000');

    } else {
      let agentId = this.currentUser._id;
      return this._httpClient.get<any>(this.apiUrlCall + '?companyId=' + this.companyId +'&agentId=' + agentId + '&limit=1000');
    }
  }

  endCall(id: string): Observable<any> {
    return this._httpClient.post<any>(this.apiUrlCall + '/' + id + '/end', {});
  }

  reconenctCall(id: string): Observable<any> {
    return this._httpClient.post<any>(this.apiUrlCall + '/' + id + '/join', {});
  }

  getCall(id: any): Observable<any> {
    return this._httpClient.get<any>(this.apiUrlCall + '/' + id);
  }

  saveChatMessage(id: any, data: any): Observable<any> {
    return this._httpClient.post<any>(this.apiUrlCall + '/' + id + '/chat', data);
  }

  // Add Call
  addCall(data: any): Observable<any> {
    return this._httpClient.post<any>(this.apiUrlCall, data);
  }



  private apiUrlCustomer = environment.apiUrl + '/customers';

  // Customers List
  getCustomers(): Observable<any> {
    return this._httpClient.get<any>(this.apiUrlCustomer);
  }



  getDataTableRows(): void {
    this.rows = UsersFakeData.users;
    this.onUserListChanged.next(this.rows);
  }

  getUserById(id: string): any {
    if (!UsersFakeData.users) return null;
    return UsersFakeData.users.find((user: any) => user.id == id);
  }

}

